import { CategoryOrAnd } from "./value";

export type CategoryOrAndType = keyof typeof CategoryOrAnd;
